import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardAt16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={14}
            className={customClassName}
            name="IconClipboardAt16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 1h4a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1M3.584 1a1.5 1.5 0 0 1 1.414-1h4a1.5 1.5 0 0 1 1.415 1H11a2 2 0 0 1 2 2v1.906a4.1 4.1 0 0 0-1-.835V3a1 1 0 0 0-1-1h-.586a1.5 1.5 0 0 1-1.415 1H5a1.5 1.5 0 0 1-1.414-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h.071c.224.377.507.714.835 1H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm4.665 9.75c.594 0 1.25-.57 1.25-1.5s-.656-1.5-1.25-1.5S7 8.32 7 9.25s.656 1.5 1.25 1.5m1.35-3.5a2.1 2.1 0 0 0-1.35-.5C7.008 6.75 6 7.87 6 9.25s1.008 2.5 2.25 2.5c.562 0 1.076-.229 1.47-.607.198.26.511.428.864.428h.75c.92 0 1.666-.746 1.666-1.666V8.5a4 4 0 0 0-4-4H7.5a4 4 0 0 0-4 4V10a4 4 0 0 0 4 4h4.928a.5.5 0 1 0 0-1H7.5a3 3 0 0 1-3-3V8.5a3 3 0 0 1 3-3H9a3 3 0 0 1 3 3v1.405a.667.667 0 0 1-.666.666h-.75a.083.083 0 0 1-.084-.083V7.55a.5.5 0 0 0-.9-.3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardAt16);
